/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'bot-detection-policy';
const componentName = 'bot-mapping-rule';
const prefix = `${moduleName}.${componentName}`;

export const botMappingRuleLabel = `${prefix}.botMappingRuleLabel`;

export const ENGLISH = {
    [botMappingRuleLabel]: 'Bot Mapping Rule',
};
